
// import React, { useEffect, useState } from "react";
// import { Link, useNavigate, useParams } from "react-router-dom";
// import { Modal, Button, Alert, Card, Row, Col, Spinner } from "react-bootstrap";
// import { createFlightBanner, updateFlightBanner, fetchFlightBannerById, fetchGalleryImageUpdate } from "../../services/userservice";

// const AddFlightBanner = () => {
//     const navigate = useNavigate();
//     const { id } = useParams();

//     const [formData, setFormData] = useState({
//         title: "",
//         banner_image: "",
//         sub_banners: [], 
//         is_active: true,
//     });

//     const [previewMainImage, setPreviewMainImage] = useState("");
//     const [previewSubImages, setPreviewSubImages] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [uploading, setUploading] = useState({
//         main: false,
//         sub: false
//     });
//     const [errorMsg, setErrorMsg] = useState(null);
//     const [showModal, setShowModal] = useState(false);
//     const [baseUrl, setBaseUrl] = useState({
//         banner: "",
//         sub: ""
//     });

//     const transformSubBanners = (subBanners) => {
//         if (!subBanners || !Array.isArray(subBanners)) return [];
//         return subBanners.map(item => {
//             if (typeof item === 'string') return item;
//             if (item && typeof item === 'object' && item.sub_banner_image) {
//                 return item.sub_banner_image;
//             }
//             return item;
//         });
//     };

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setFormData((prev) => ({ ...prev, [name]: value }));
//     };

//     const handleStatusChange = (e) => {
//         setFormData((prev) => ({ ...prev, is_active: e.target.value === "true" }));
//     };

//     const handleMainBannerUpload = async (e) => {
//         const file = e.target.files[0];
//         if (!file) return;

//         setUploading(prev => ({ ...prev, main: true }));
//         const formDataData = new FormData();
//         formDataData.append("profile_pic", file);
//         formDataData.append("type", "banner");

//         try {
//             const response = await fetchGalleryImageUpdate(formDataData);
//             const uploadedFile = response?.data?.files?.[0];

//             if (uploadedFile) {
//                 const { home_banner_url, base_url } = uploadedFile;
//                 setFormData((prev) => ({
//                     ...prev,
//                     banner_image: home_banner_url,
//                 }));
//                 setPreviewMainImage(base_url + home_banner_url);
//             }
//         } catch (error) {
//             console.error("Error uploading image:", error);
//             setErrorMsg("Failed to upload banner image");
//         } finally {
//             setUploading(prev => ({ ...prev, main: false }));
//         }
//     };

//     const handleSubBannerUpload = async (e) => {
//         const files = Array.from(e.target.files);
//         if (!files.length) return;

//         setUploading(prev => ({ ...prev, sub: true }));
//         const uploadedFilenames = [];
//         const previewUrls = [];

//         try {
//             for (let file of files) {
//                 const uploadData = new FormData();
//                 uploadData.append("profile_pic", file);
//                 uploadData.append("type", "gallery");

//                 const response = await fetchGalleryImageUpdate(uploadData);
//                 const uploadedFile = response?.data?.files?.[0];

//                 if (uploadedFile) {
//                     uploadedFilenames.push(uploadedFile.image_url);
//                     previewUrls.push(uploadedFile.base_url + uploadedFile.image_url);
//                 }
//             }

//             setFormData((prev) => ({
//                 ...prev,
//                 sub_banners: [...prev.sub_banners, ...uploadedFilenames],
//             }));

//             setPreviewSubImages((prev) => [...prev, ...previewUrls]);
//         } catch (error) {
//             console.error("Error uploading sub banner:", error);
//             setErrorMsg("Failed to upload sub banners");
//         } finally {
//             setUploading(prev => ({ ...prev, sub: false }));
//         }
//     };

//     const removeSubBanner = (index) => {
//         setFormData((prev) => ({
//             ...prev,
//             sub_banners: prev.sub_banners.filter((_, i) => i !== index)
//         }));
//         setPreviewSubImages((prev) => prev.filter((_, i) => i !== index));
//     };

//     const prepareSubmitData = () => {
//         const submitData = {
//             title: formData.title,
//             banner_image: formData.banner_image,
//             is_active: formData.is_active,
//             sub_banners: formData.sub_banners.map(item => {
//                 if (typeof item === 'string') return item;
//                 if (item && typeof item === 'object' && item.sub_banner_image) {
//                     return item.sub_banner_image;
//                 }
//                 return item;
//             })
//         };
        
//         console.log("Submitting data:", submitData);
//         return submitData;
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setLoading(true);
//         setErrorMsg(null);

//         try {
//             const submitData = prepareSubmitData();
            
//             if (id) {
//                 await updateFlightBanner(id, submitData);
//             } else {
//                 await createFlightBanner(submitData);
//             }

//             setShowModal(true);
//             setTimeout(() => {
//                 navigate("/flight-banner");
//                 setShowModal(false);
//             }, 2000);
//         } catch (err) {
//             setErrorMsg(err.message || "Something went wrong!");
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         if (id) {
//             const fetchBanner = async () => {
//                 try {
//                     setLoading(true);
//                     const res = await fetchFlightBannerById(id);
//                     const transformedSubBanners = transformSubBanners(res?.sub_banners);

//                     setFormData({
//                         title: res?.title || "",
//                         banner_image: res?.banner_image || "",
//                         sub_banners: transformedSubBanners, 
//                         is_active: res?.is_active ?? true,
//                     });

//                     setBaseUrl({
//                         banner: res?.banner_url || "",
//                         sub: res?.sub_banner_url || "",
//                     });

//                     setPreviewMainImage(res?.banner_url + res?.banner_image);
//                     const subBannerPreviews = transformedSubBanners.map(
//                         filename => res?.sub_banner_url + filename
//                     );
//                     setPreviewSubImages(subBannerPreviews);

//                 } catch (err) {
//                     setErrorMsg(err.message || "Error loading banner");
//                 } finally {
//                     setLoading(false);
//                 }
//             };
//             fetchBanner();
//         }
//     }, [id]);

//     const currentSubBanners = formData.sub_banners;

//     return (
//           <div className="content-wrapper">
//                    <div className="content-header">
//                        <div className="container-fluid">
//                            <div className="row mb-2">
//                                <div className="col-sm-6">
//                                    <h1 className="m-0 text-dark">
//                                        {id ? "Edit Flight Banner" : "Add Flight Banner"}
//                                    </h1>
//                                </div>
//                                <div className="col-sm-6">
//                                    <ol className="breadcrumb float-sm-right">
//                                        <li className="breadcrumb-item">
//                                            <Link to="/dashboard">Home</Link>
//                                        </li>
//                                        <li className="breadcrumb-item">
//                                            <Link to="/flight-banner">Flight Banners</Link>
//                                        </li>
//                                        <li className="breadcrumb-item active">
//                                            {id ? "Edit" : "Add"}
//                                        </li>
//                                    </ol>
//                                </div>
//                            </div>
//                        </div>
//                    </div>
       
//                    <section className="content">
//                        <div className="container-fluid">
//                            {errorMsg && (
//                                <Alert variant="danger" onClose={() => setErrorMsg(null)} dismissible>
//                                    {errorMsg}
//                                </Alert>
//                            )}
       
//                            <form onSubmit={handleSubmit}>
//                                <div className="card">
//                                    <div className="card-body">
//                                        <div className="row">
       
//                                            <Col lg={6}>
//                                                <div className="form-group">
//                                                    <label htmlFor="title">Title *</label>
//                                                    <input
//                                                        type="text"
//                                                        className="form-control"
//                                                        id="title"
//                                                        name="title"
//                                                        value={formData.title}
//                                                        onChange={handleInputChange}
//                                                        placeholder="Enter banner title"
//                                                        required
//                                                    />
//                                                </div>
//                                            </Col>
//                                            <Col lg={6}>
//                                                <div className="form-group">
//                                                    <label>Status</label>
//                                                    <select
//                                                        className="form-control"
//                                                        value={formData.is_active}
//                                                        onChange={handleStatusChange}
//                                                    >
//                                                        <option value="true">Active</option>
//                                                        <option value="false">Inactive</option>
//                                                    </select>
//                                                </div>
       
//                                            </Col>
//                                            <Col lg={12}>
       
//                                                {/* Banner Image */}
//                                                <div className="form-group">
//                                                    <label htmlFor="bannerImage">Banner Image *</label>
//                                                    <div className="custom-file">
//                                                        <input
//                                                            type="file"
//                                                            className="custom-file-input"
//                                                            id="bannerImage"
//                                                            onChange={handleMainBannerUpload}
//                                                            accept="image/*"
//                                                        />
//                                                        <label className="custom-file-label" htmlFor="bannerImage">
//                                                            {uploading.main ? "Uploading..." : "Choose banner image"}
//                                                        </label>
//                                                    </div>
//                                                    {uploading.main && (
//                                                        <div className="mt-2">
//                                                            <Spinner animation="border" size="sm" className="mr-2" />
//                                                            Uploading banner image...
//                                                        </div>
//                                                    )}
//                                                </div>
       
//                                                {/* Banner Preview */}
//                                                {(previewMainImage || formData.banner_image) && (
//                                                    <div className="form-group">
//                                                        <label>Banner Preview</label>
//                                                        <div className="border rounded p-3">
//                                                            <img
//                                                                src={previewMainImage || baseUrl.banner + formData.banner_image}
//                                                                alt="Banner Preview"
//                                                                className="img-fluid rounded"
//                                                                style={{
//                                                                    maxHeight: '300px',
//                                                                    objectFit: 'contain'
//                                                                }}
//                                                            />
//                                                        </div>
//                                                    </div>
//                                                )}
//                                            </Col>
//                                            <Col lg={12}>
//                                                {/* Sub Banners */}
//                                                <div className="form-group">
//                                                    <label htmlFor="subBanners">Sub Banners</label>
//                                                    <div className="custom-file">
//                                                        <input
//                                                            type="file"
//                                                            className="custom-file-input"
//                                                            id="subBanners"
//                                                            multiple
//                                                            onChange={handleSubBannerUpload}
//                                                            accept="image/*"
//                                                        />
//                                                        <label className="custom-file-label" htmlFor="subBanners">
//                                                            {uploading.sub ? "Uploading..." : "Choose sub banner images"}
//                                                        </label>
//                                                    </div>
//                                                    {uploading.sub && (
//                                                        <div className="mt-2">
//                                                            <Spinner animation="border" size="sm" className="mr-2" />
//                                                            Uploading sub banners...
//                                                        </div>
//                                                    )}
//                                                    <small className="form-text text-muted">
//                                                        You can select multiple images for sub banners
//                                                    </small>
//                                                </div>
       
//                                                {/* Sub Banners Preview */}
//                                                {(previewSubImages.length > 0 || formData.sub_banners.length > 0) && (
//                                                    <div className="form-group">
//                                                         <label>Sub Banners Preview ({currentSubBanners.length} images)</label>
//                                                        <Row>
//                                                            {(previewSubImages.length > 0 ? previewSubImages :
//                                                                formData.sub_banners.map(file => baseUrl.sub + file.sub_banner_image)
//                                                            ).map((img, index) => (
//                                                                <Col key={index} xs={6} sm={4} md={3} className="mb-3">
//                                                                    <div className="position-relative">
//                                                                        <img
//                                                                            src={img}
//                                                                            alt={`Sub Banner ${index + 1}`}
//                                                                            className="img-thumbnail"
//                                                                            style={{
//                                                                                width: '100%',
//                                                                                height: '100px',
//                                                                                objectFit: 'cover'
//                                                                            }}
//                                                                        />
//                                                                        <button
//                                                                            type="button"
//                                                                            className="btn btn-danger btn-xs position-absolute"
//                                                                            style={{ top: '5px', right: '5px' }}
//                                                                            onClick={() => removeSubBanner(index)}
//                                                                        >
//                                                                            <i className="fas fa-times"></i>
//                                                                        </button>
//                                                                    </div>
//                                                                </Col>
//                                                            ))}
//                                                        </Row>
//                                                    </div>
//                                                )}
//                                            </Col>
//                                            <Col lg={12}>
//                                                <div className="d-grid gap-2 my-4">
//                                                    <button
//                                                        type="submit"
//                                                        className="btn btn-primary btn-lg"
//                                                        disabled={loading || uploading.main || uploading.sub}
//                                                    >
//                                                        {loading ? (
//                                                            <>
//                                                                <Spinner animation="border" size="sm" className="mr-2" />
//                                                                Saving...
//                                                            </>
//                                                        ) : (
//                                                            <>
//                                                                <i className="fas fa-save mr-2"></i>
//                                                                Save Banner
//                                                            </>
//                                                        )}
//                                                    </button>
       
       
//                                                    {id &&
//                                                        <Link
//                                                            to="/flight-banner"
//                                                            className="btn btn-default btn-lg mx-4"
//                                                        >
//                                                            <i className="fas fa-arrow-left mr-2"></i>
//                                                            Back to List
//                                                        </Link>
//                                                    }
//                                                </div>
//                                            </Col>
       
//                                        </div>
//                                    </div>
//                                </div>
//                            </form>
//                        </div>
//                    </section >
       
//                    < Modal show={showModal} onHide={() => setShowModal(false)} centered >
//                        <Modal.Header closeButton className="border-0">
//                            <Modal.Title className="w-100 text-center">
//                                <i className="fas fa-check-circle text-success mr-2"></i>
//                                Success
//                            </Modal.Title>
//                        </Modal.Header>
//                        <Modal.Body className="text-center py-4">
//                            <div className="mb-3">
//                                <i
//                                    className="fas fa-check-circle text-success"
//                                    style={{ fontSize: "4rem" }}
//                                ></i>
//                            </div>
//                            <h5>Flight Banner saved successfully!</h5>
//                            <p className="text-muted">Redirecting to banners list...</p>
//                        </Modal.Body>
//                        <Modal.Footer className="border-0 justify-content-center">
//                            <Button variant="success" onClick={() => setShowModal(false)}>
//                                <i className="fas fa-check mr-2"></i>
//                                Continue
//                            </Button>
//                        </Modal.Footer>
//                    </Modal >
//                </div >
//     );
// };

// export default AddFlightBanner;


import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Modal,  Button,   Alert,  Card, Row, Col,  Spinner, OverlayTrigger, Tooltip } from "react-bootstrap";
import { createFlightBanner, updateFlightBanner, fetchFlightBannerById, fetchGalleryImageUpdate } from "../../services/userservice";

const AddFlightBanner = () => {
    const navigate = useNavigate();
    const { id } = useParams();

    const [formData, setFormData] = useState({
        title: "",
        banner_image: "",
        sub_banners: [], 
        is_active: true,
    });

    const [previewMainImage, setPreviewMainImage] = useState("");
    const [previewSubImages, setPreviewSubImages] = useState([]);
    const [loading, setLoading] = useState(false);
    const [uploading, setUploading] = useState({
        main: false,
        sub: false
    });
    const [errorMsg, setErrorMsg] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [baseUrl, setBaseUrl] = useState({
        banner: "",
        sub: ""
    });

    const BannerUploadTooltip = (props) => (
        <Tooltip id="banner-upload-tooltip" {...props}>
            <div className="text-left">
                <strong>Main Banner Specifications:</strong>
                <div className="small">
                    <div>📐 <strong>Dimensions:</strong> 1920x1080 pixels (Recommended)</div>
                    <div>📁 <strong>Formats:</strong> JPG, PNG, WebP, AVIF</div>
                    <div>💾 <strong>Max Size:</strong> 3MB</div>
                    <div>📍 <strong>Display:</strong> Homepage main banner section</div>
                    <div>🎯 <strong>Purpose:</strong> Primary promotional banner</div>
                </div>
            </div>
        </Tooltip>
    );

    const SubBannerUploadTooltip = (props) => (
        <Tooltip id="sub-banner-upload-tooltip" {...props}>
            <div className="text-left">
                <strong>Sub-Banners Specifications:</strong>
                <div className="small">
                    <div>📐 <strong>Dimensions:</strong> 300x100 pixels (Recommended)</div>
                    <div>📁 <strong>Formats:</strong> JPG, PNG, WebP, AVIF</div>
                    <div>💾 <strong>Max Size:</strong> 1MB per image</div>
                    <div>📍 <strong>Display:</strong> Secondary banner sections</div>
                    <div>🎯 <strong>Purpose:</strong> Supporting promotional content</div>
                    <div>📎 <strong>Multiple:</strong> You can upload multiple images</div>
                </div>
            </div>
        </Tooltip>
    );

    const SuccessTooltip = (props) => (
        <Tooltip id="success-tooltip" {...props}>
            <div className="text-center">
                <i className="fas fa-check-circle text-success mr-1"></i>
                Image uploaded successfully!
            </div>
        </Tooltip>
    );

    const UploadTypeTooltip = (props) => (
        <Tooltip id="upload-type-tooltip" {...props}>
            <div className="text-left">
                <strong>Upload Type Information:</strong>
                <div className="small">
                    <div><strong>Main Banner:</strong> "banner" type</div>
                    <div><strong>Sub Banners:</strong> "gallery" type</div>
                    <br />
                    <div>Different types help organize images in the system.</div>
                </div>
            </div>
        </Tooltip>
    );

    const transformSubBanners = (subBanners) => {
        if (!subBanners || !Array.isArray(subBanners)) return [];
        return subBanners.map(item => {
            if (typeof item === 'string') return item;
            if (item && typeof item === 'object' && item.sub_banner_image) {
                return item.sub_banner_image;
            }
            return item;
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleStatusChange = (e) => {
        setFormData((prev) => ({ ...prev, is_active: e.target.value === "true" }));
    };

     const handleMainBannerUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setUploading(prev => ({ ...prev, main: true }));
        const formDataData = new FormData();
        formDataData.append("profile_pic", file);
        formDataData.append("type", "banner");

        try {
            const response = await fetchGalleryImageUpdate(formDataData);
            const uploadedFile = response?.data?.files?.[0];

            if (uploadedFile) {
                const { home_banner_url, base_url } = uploadedFile;
                setFormData((prev) => ({
                    ...prev,
                    banner_image: home_banner_url,
                }));
                setPreviewMainImage(base_url + home_banner_url);
            }
        } catch (error) {
            console.error("Error uploading image:", error);
            setErrorMsg("Failed to upload banner image");
        } finally {
            setUploading(prev => ({ ...prev, main: false }));
        }
    };

    const handleSubBannerUpload = async (e) => {
        const files = Array.from(e.target.files);
        if (!files.length) return;

        setUploading(prev => ({ ...prev, sub: true }));
        const uploadedFilenames = [];
        const previewUrls = [];

        try {
            for (let file of files) {
                const uploadData = new FormData();
                uploadData.append("profile_pic", file);
                uploadData.append("type", "gallery");

                const response = await fetchGalleryImageUpdate(uploadData);
                const uploadedFile = response?.data?.files?.[0];

                if (uploadedFile) {
                    uploadedFilenames.push(uploadedFile.image_url);
                    previewUrls.push(uploadedFile.base_url + uploadedFile.image_url);
                }
            }

            setFormData((prev) => ({
                ...prev,
                sub_banners: [...prev.sub_banners, ...uploadedFilenames],
            }));

            setPreviewSubImages((prev) => [...prev, ...previewUrls]);
        } catch (error) {
            console.error("Error uploading sub banner:", error);
            setErrorMsg("Failed to upload sub banners");
        } finally {
            setUploading(prev => ({ ...prev, sub: false }));
        }
    };

    const removeSubBanner = (index) => {
        setFormData((prev) => ({
            ...prev,
            sub_banners: prev.sub_banners.filter((_, i) => i !== index)
        }));
        setPreviewSubImages((prev) => prev.filter((_, i) => i !== index));
    };

    const prepareSubmitData = () => {
        const submitData = {
            title: formData.title,
            banner_image: formData.banner_image,
            is_active: formData.is_active,
            sub_banners: formData.sub_banners.map(item => {
                if (typeof item === 'string') return item;
                if (item && typeof item === 'object' && item.sub_banner_image) {
                    return item.sub_banner_image;
                }
                return item;
            })
        };
        
        console.log("Submitting data:", submitData);
        return submitData;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrorMsg(null);

        try {
            const submitData = prepareSubmitData();
            
            if (id) {
                await updateFlightBanner(id, submitData);
            } else {
                await createFlightBanner(submitData);
            }

            setShowModal(true);
            setTimeout(() => {
                navigate("/flight-banner");
                setShowModal(false);
            }, 2000);
        } catch (err) {
            setErrorMsg(err.message || "Something went wrong!");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (id) {
            const fetchBanner = async () => {
                try {
                    setLoading(true);
                    const res = await fetchFlightBannerById(id);
                    const transformedSubBanners = transformSubBanners(res?.sub_banners);

                    setFormData({
                        title: res?.title || "",
                        banner_image: res?.banner_image || "",
                        sub_banners: transformedSubBanners, 
                        is_active: res?.is_active ?? true,
                    });

                    setBaseUrl({
                        banner: res?.banner_url || "",
                        sub: res?.sub_banner_url || "",
                    });

                    setPreviewMainImage(res?.banner_url + res?.banner_image);
                    const subBannerPreviews = transformedSubBanners.map(
                        filename => res?.sub_banner_url + filename
                    );
                    setPreviewSubImages(subBannerPreviews);

                } catch (err) {
                    setErrorMsg(err.message || "Error loading banner");
                } finally {
                    setLoading(false);
                }
            };
            fetchBanner();
        }
    }, [id]);

    const currentSubBanners = formData.sub_banners;

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0 text-dark">
                                {id ? "Edit Flight Banner" : "Add Flight Banner"}
                            </h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Home</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to="/flight-banner">Flight Banners</Link>
                                </li>
                                <li className="breadcrumb-item active">
                                    {id ? "Edit" : "Add"}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <section className="content">
                <div className="container-fluid">
                    {errorMsg && (
                        <Alert variant="danger" onClose={() => setErrorMsg(null)} dismissible>
                            {errorMsg}
                        </Alert>
                    )}

                    <form onSubmit={handleSubmit}>
                        <div className="card">
                            <div className="card-body">
                                <div className="row">

                                    <Col lg={6}>
                                        <div className="form-group">
                                            <label htmlFor="title">Title *</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="title"
                                                name="title"
                                                value={formData.title}
                                                onChange={handleInputChange}
                                                placeholder="Enter banner title"
                                                required
                                            />
                                        </div>
                                    </Col>
                                    <Col lg={6}>
                                        <div className="form-group">
                                            <label>Status</label>
                                            <select
                                                className="form-control"
                                                value={formData.is_active}
                                                onChange={handleStatusChange}
                                            >
                                                <option value="true">Active</option>
                                                <option value="false">Inactive</option>
                                            </select>
                                        </div>
                                    </Col>
                                    
                                    <Col lg={12}>
                                        {/* Banner Image Section */}
                                        <div className="form-group">
                                            <label htmlFor="bannerImage">
                                                Banner Image *
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={BannerUploadTooltip}
                                                >
                                                    <small className="text-muted ml-2" style={{ cursor: 'help' }}>
                                                        <i className="fas fa-info-circle"></i> View specifications
                                                    </small>
                                                </OverlayTrigger>
                                            </label>
                                            <div className="custom-file">
                                                <input
                                                    type="file"
                                                    className="custom-file-input"
                                                    id="bannerImage"
                                                    onChange={handleMainBannerUpload}
                                                    accept="image/jpeg, image/jpg, image/png, image/webp, image/avif"
                                                />
                                                <label className="custom-file-label" htmlFor="bannerImage">
                                                    {uploading.main ? "Uploading..." : "Choose banner image"}
                                                </label>
                                            </div>
                                            {uploading.main && (
                                                <div className="mt-2">
                                                    <Spinner animation="border" size="sm" className="mr-2" />
                                                    <small>Uploading main banner as <strong>"banner"</strong> type...</small>
                                                </div>
                                            )}
                                            {formData.banner_image && !uploading.main && (
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={SuccessTooltip}
                                                >
                                                    <div className="mt-2 text-success">
                                                        <i className="fas fa-check-circle mr-1"></i>
                                                        <small>Main banner uploaded successfully!</small>
                                                    </div>
                                                </OverlayTrigger>
                                            )}
                                         
                                        </div>

                                        {/* Banner Preview */}
                                        {(previewMainImage || formData.banner_image) && (
                                            <div className="form-group">
                                                <label>
                                                    Banner Preview 
                                                </label>
                                                <div className="border rounded p-3">
                                                    <img
                                                        src={previewMainImage || baseUrl.banner + formData.banner_image}
                                                        alt="Banner Preview"
                                                        className="img-fluid rounded"
                                                        style={{
                                                            maxHeight: '300px',
                                                            objectFit: 'contain'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </Col>
                                    
                                    <Col lg={12}>
                                        {/* Sub Banners Section */}
                                        <div className="form-group">
                                            <label htmlFor="subBanners">
                                                Sub Banners
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={SubBannerUploadTooltip}
                                                >
                                                    <small className="text-muted ml-2" style={{ cursor: 'help' }}>
                                                        <i className="fas fa-info-circle"></i> View specifications
                                                    </small>
                                                </OverlayTrigger>
                                            </label>
                                            <div className="custom-file">
                                                <input
                                                    type="file"
                                                    className="custom-file-input"
                                                    id="subBanners"
                                                    multiple
                                                    onChange={handleSubBannerUpload}
                                                    accept="image/jpeg, image/jpg, image/png, image/webp, image/avif"
                                                />
                                                <label className="custom-file-label" htmlFor="subBanners">
                                                    {uploading.sub ? "Uploading..." : "Choose sub banner images"}
                                                </label>
                                            </div>
                                            {uploading.sub && (
                                                <div className="mt-2">
                                                    <Spinner animation="border" size="sm" className="mr-2" />
                                                    <small>Uploading sub banners as <strong>"gallery"</strong> type...</small>
                                                </div>
                                            )}
                                            {currentSubBanners.length > 0 && !uploading.sub && (
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={SuccessTooltip}
                                                >
                                                    <div className="mt-2 text-success">
                                                        <i className="fas fa-check-circle mr-1"></i>
                                                        <small>{currentSubBanners.length} sub-banner(s) uploaded successfully!</small>
                                                    </div>
                                                </OverlayTrigger>
                                            )}

                                        </div>

                                        {/* Sub Banners Preview */}
                                        {(previewSubImages.length > 0 || formData.sub_banners.length > 0) && (
                                            <div className="form-group">
                                                <label>
                                                    Sub Banners Preview ({currentSubBanners.length} images) 
                                                </label>
                                                <Row>
                                                    {(previewSubImages.length > 0 ? previewSubImages :
                                                        formData.sub_banners.map(file => baseUrl.sub + file.sub_banner_image)
                                                    ).map((img, index) => (
                                                        <Col key={index} xs={6} sm={4} md={3} className="mb-3">
                                                            <div className="position-relative">
                                                                <img
                                                                    src={img}
                                                                    alt={`Sub Banner ${index + 1}`}
                                                                    className="img-thumbnail"
                                                                    style={{
                                                                        width: '100%',
                                                                        height: '100px',
                                                                        objectFit: 'cover'
                                                                    }}
                                                                />
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-danger btn-xs position-absolute"
                                                                    style={{ top: '5px', right: '5px' }}
                                                                    onClick={() => removeSubBanner(index)}
                                                                >
                                                                    <i className="fas fa-times"></i>
                                                                </button>
                                                            </div>
                                                        </Col>
                                                    ))}
                                                </Row>
                                            </div>
                                        )}
                                    </Col>
                                    
                                    <Col lg={12}>
                                        <div className="d-grid gap-2 my-4">
                                            <button
                                                type="submit"
                                                className="btn btn-primary btn-lg"
                                                disabled={loading || uploading.main || uploading.sub}
                                            >
                                                {loading ? (
                                                    <>
                                                        <Spinner animation="border" size="sm" className="mr-2" />
                                                        Saving...
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="fas fa-save mr-2"></i>
                                                        Save Banner
                                                    </>
                                                )}
                                            </button>

                                            {id &&
                                                <Link
                                                    to="/flight-banner"
                                                    className="btn btn-default btn-lg mx-4"
                                                >
                                                    <i className="fas fa-arrow-left mr-2"></i>
                                                    Back to List
                                                </Link>
                                            }
                                        </div>
                                    </Col>

                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </section>

            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton className="border-0">
                    <Modal.Title className="w-100 text-center">
                        <i className="fas fa-check-circle text-success mr-2"></i>
                        Success
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center py-4">
                    <div className="mb-3">
                        <i
                            className="fas fa-check-circle text-success"
                            style={{ fontSize: "4rem" }}
                        ></i>
                    </div>
                    <h5>Flight Banner saved successfully!</h5>
                    <p className="text-muted">Redirecting to banners list...</p>
                </Modal.Body>
                <Modal.Footer className="border-0 justify-content-center">
                    <Button variant="success" onClick={() => setShowModal(false)}>
                        <i className="fas fa-check mr-2"></i>
                        Continue
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default AddFlightBanner;